var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.825 10.0125V5.175C8.825 4.9875 8.8875 4.83125 9.0125 4.70625C9.15 4.56875 9.3125 4.5 9.5 4.5C9.6875 4.5 9.84375 4.56875 9.96875 4.70625C10.1063 4.83125 10.175 4.9875 10.175 5.175V10.0125L11.675 8.5125C11.8125 8.375 11.9688 8.30625 12.1438 8.30625C12.3313 8.30625 12.4938 8.375 12.6313 8.5125C12.7688 8.65 12.8375 8.8125 12.8375 9C12.8375 9.175 12.7688 9.33125 12.6313 9.46875L9.96875 12.1312C9.83125 12.2687 9.675 12.3375 9.5 12.3375C9.325 12.3375 9.16875 12.2687 9.03125 12.1312L6.36875 9.46875C6.23125 9.33125 6.1625 9.175 6.1625 9C6.175 8.8125 6.25 8.65 6.3875 8.5125C6.525 8.375 6.68125 8.30625 6.85625 8.30625C7.04375 8.30625 7.20625 8.375 7.34375 8.5125L8.825 10.0125Z",
    fill: "#5F30E2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowDownIcon.a936dfefaf104386ede733ef6bb2ac33.svg";